<template>
  <a-select
    :disabled="disabled"
    :filterOption="false"
    :getPopupContainer="getParentContainer"
    :notFoundContent="loading ? undefined : null"
    :placeholder="placeholder"
    @change="handleAsyncChange"
    @search="loadData"
    allowClear
    labelInValue
    showSearch
    style="width: 100%"
    v-if="async"
    v-model="selectedAsyncValue"
  >
    <a-spin size="small" slot="notFoundContent" v-if="loading" />
    <a-select-option :key="d.value" :value="d.value" v-for="d in options">{{ d.text }}</a-select-option>
  </a-select>

  <a-select
    :disabled="disabled"
    :filterOption="filterOption"
    :getPopupContainer="getParentContainer"
    :notFoundContent="loading ? undefined : null"
    :placeholder="placeholder"
    @change="handleChange"
    allowClear
    optionFilterProp="children"
    showSearch
    style="width: 100%"
    v-else
    v-model="selectedValue"
  >
    <a-spin size="small" slot="notFoundContent" v-if="loading" />
    <a-select-option :key="d.value" :value="d.value" v-for="d in options">{{ d.text }}</a-select-option>
  </a-select>
</template>

<script>
import { ajaxGetDictItems, getDictItemsFromCache } from '@/api/api'
import debounce from 'lodash/debounce'
import { getAction } from '../../api/manage'

export default {
  name: 'JSearchSelectTag',
  props: {
    disabled: Boolean,
    value: [String, Number],
    dictOptions: Array,
    async: Boolean,
    params: {
      type: Object,
      default: () => {}
    },
    placeholder: {
      type: String,
      default: '请选择',
      required: false
    },
    dict: {
      type: String,
      default: '',
      required: false
    },
    popContainer: {
      type: String,
      default: '',
      required: false
    },
    pageSize: {
      type: Number,
      default: 10,
      required: false
    },
    getPopupContainer: {
      type: Function,
      default: null
    },
    tenant: {
      type: String,
      default: ''
    }
  },
  data() {
    this.loadData = debounce(this.loadData, 800) //消抖
    this.lastLoad = 0
    return {
      loading: false,
      selectedValue: [],
      selectedAsyncValue: [],
      options: []
    }
  },
  created() {
    this.initDictData()
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (!val) {
          if (val == 0) {
            this.initSelectValue()
          } else {
            this.selectedValue = []
            this.selectedAsyncValue = []
          }
        } else {
          this.initSelectValue()
        }
      }
    },
    dict: {
      handler() {
        this.initDictData()
      }
    },
    dictOptions: {
      deep: true,
      handler(val) {
        if (val && val.length > 0) {
          this.options = [...val]
        }
      }
    }
  },
  methods: {
    initSelectValue() {
      if (this.async) {
        if (!this.selectedAsyncValue || !this.selectedAsyncValue.key || this.selectedAsyncValue.key != this.value) {
          console.log('这才请求后台')
          getAction(`/sys/dict/loadDictItem/${this.dict}`, { key: this.value }).then(res => {
            if (res.success) {
              let obj = {
                key: this.value,
                label: res.result
              }
              this.selectedAsyncValue = { ...obj }
            }
          })
        }
      } else {
        this.selectedValue = this.value.toString()
      }
    },
    loadData(value) {
      console.log('数据加载', value)
      this.lastLoad += 1
      const currentLoad = this.lastLoad
      this.options = []
      this.loading = true
      const params = { keyword: value, pageSize: this.pageSize }
      if (this.params) {
        params[this.params.paramsKey] = this.params.paramsValue
      }
      // 字典code格式：table,text,code
      getAction(`/sys/dict/loadDict/${this.dict}`, params).then(res => {
        this.loading = false
        if (res.success) {
          if (currentLoad != this.lastLoad) {
            return
          }
          this.options = res.result
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    initDictData() {
      const dict = this.tenant ? this.dict + `,${this.tenant}=${this.$ls.get('TENANT_ID')}` : this.dict

      if (!this.async) {
        //如果字典项集合有数据
        if (this.dictOptions && this.dictOptions.length > 0) {
          this.options = [...this.dictOptions]
        } else {
          //根据字典Code, 初始化字典数组
          let dictStr = ''
          if (dict) {
            let arr = dict.split(',')
            if (arr[0].indexOf('where') > 0) {
              let tbInfo = arr[0].split('where')
              dictStr = tbInfo[0].trim() + ',' + arr[1] + ',' + arr[2] + ',' + encodeURIComponent(tbInfo[1])
            } else {
              dictStr = dict
            }
            if (dict.indexOf(',') == -1) {
              //优先从缓存中读取字典配置
              if (getDictItemsFromCache(this.dictCode)) {
                this.options = getDictItemsFromCache(this.dictCode)
                return
              }
            }
            ajaxGetDictItems(dictStr, null).then(res => {
              if (res.success) {
                this.options = res.result
              }
            })
          }
        }
      } else {
        if (!this.dict) {
          console.error('搜索组件未配置字典项')
        } else {
          //异步一开始也加载一点数据
          this.loading = true
          getAction(`/sys/dict/loadDict/${dict}`, { pageSize: this.pageSize, keyword: '' }).then(res => {
            this.loading = false
            if (res.success) {
              this.options = res.result
            } else {
              this.$message.warning(res.message)
            }
          })
        }
      }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleChange(selectedValue, option) {
      console.log('selectedValue', selectedValue)
      this.selectedValue = selectedValue
      this.selectedText = option?.componentOptions?.children[0]?.text
      this.callback()
    },
    handleAsyncChange(selectedObj, option) {
      //update-begin-author:scott date:20201222 for:【搜索】搜索查询组件，删除条件，默认下拉还是上次的缓存数据，不好 JT-191
      if (selectedObj) {
        this.selectedAsyncValue = selectedObj
        this.selectedValue = selectedObj.key
      } else {
        this.selectedAsyncValue = null
        this.selectedValue = null
        this.options = null
        this.loadData('')
      }
      this.callback()
      //update-end-author:scott date:20201222 for:【搜索】搜索查询组件，删除条件，默认下拉还是上次的缓存数据，不好 JT-191
    },
    callback() {
      this.$emit('change', this.selectedValue, this.selectedText)
    },
    setCurrentDictOptions(dictOptions) {
      this.options = dictOptions
    },
    getCurrentDictOptions() {
      return this.options
    },
    getParentContainer(node) {
      if (typeof this.getPopupContainer === 'function') {
        return this.getPopupContainer(node)
      } else if (!this.popContainer) {
        return node.parentNode
      } else {
        return document.querySelector(this.popContainer)
      }
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  }
}
</script>

<style scoped>

</style>
